<ifc-id-verse-header [logoUrl]="headerLogoUrl"></ifc-id-verse-header>

<mat-divider
  *ngIf="deviceData?.type === DeviceType.Desktop"
  class="divider"
></mat-divider>

<h2 class="title">Choose How You'd Like to Verify</h2>

<section class="cards">
  <div class="card">
    <ng-container *ngIf="deviceData?.type === DeviceType.Desktop">
      <h3 class="card__title">Continue on the Web Browser</h3>
      <p class="card__description">
        After pressing Continue, you will need your mobile device to scan the QR
        to start IDVerse Identity Verification.
      </p>
    </ng-container>
    <ng-container *ngIf="deviceData?.type === DeviceType.Mobile || deviceData?.type === DeviceType.Tablet">
      <p class="card__description">
        No app download required. Complete your verification directly in this
        browser using your smartphone camera.
      </p>
    </ng-container>
    <button
      mat-flat-button
      color="primary"
      class="card__button"
      (click)="onClickContinueInBrowser()"
    >
      CONTINUE IN BROWSER
    </button>
  </div>

  <div class="card">
    <ng-container *ngIf="deviceData?.type === DeviceType.Desktop">
      <h3 class="card__title">Continue in the Mobile App</h3>
      <p class="card__description">
        Scan the QR code &amp; download Idea Financial mobile app to complete
        your verification with ease.
      </p>
      <qrcode
        [qrdata]="qrCodeUrl"
        [width]="100"
        [errorCorrectionLevel]="'M'"
        [imageSrc]="qrLogoUrl"
        [imageHeight]="24"
        [imageWidth]="24"
        [margin]="1"
      >
      </qrcode>
      <div class="stores">
        <img
          *ngIf="playStoreUrl"
          class="stores__item"
          src="assets/img/banner/google-play.svg"
          alt="Get it on Google Play"
          (click)="onClickGooglePlay()"
        />
        <img
          *ngIf="appStoreUrl"
          class="stores__item"
          src="assets/img/banner/apple-store.svg"
          alt="Download on the App Store"
          (click)="onClickAppleStore()"
        />
      </div>
    </ng-container>
    <ng-container *ngIf="deviceData?.type === DeviceType.Mobile || deviceData?.type === DeviceType.Tablet">
      <p class="card__description">
        Download the Idea Financial mobile app to complete your verification
        with ease.
      </p>
      <button
        mat-flat-button
        color="primary"
        class="card__button"
        (click)="onClickContinueInApp()"
      >
        CONTINUE IN MOBILE APP
      </button>
    </ng-container>
  </div>
</section>
